var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.buttonType,{tag:"component",staticClass:"app-button",class:[_vm.buttonSize, _vm.buttonColor],attrs:{"href":_vm.link}},[_c('div',{staticClass:"app-button__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }